import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { actions } from "store";
import { arrayIsEqual, tableColumn } from "utils";
import { ActionButton, TableList } from "components/common";


class DistrictList extends Component {
  state = {
    columnList: ['name', 'profile_count', 'actions'],
    columnByName: {
      name: tableColumn('Название', 'name', {
        sorter: true,
      }),
      profile_count: tableColumn('Кол-во анкет', 'profile_count', {
        width: 150,
        sorter: true,
      }),
      actions: tableColumn('', 'actions', {
        align: 'right',
        render: (val, item) => (
          <ActionButton
            actions={[{
              title: 'Редактировать', key: 'edit', icon: 'edit', action: () => this.showEditForm(item),
            }, {
              title: 'Удалить', key: 'delete', icon: 'delete', action: () => this.delete(item),
              confirm: {
                title: 'Уверены, что хотите удалить?',
                okText: 'Удалить',
                cancelText: 'Отмена'
              }
            }]}
          />
        ),
      }),
    },
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const { columnList } = nextProps;
    if (columnList && !arrayIsEqual(prevState.columnList, columnList)) {
      return {
        columnList: columnList,
      }
    }
    return null;
  }

  load = ({ query, activeFilter }) => {
    this.props.actions.districtListLoad({ query, activeFilter });
  };

  showEditForm = (item) => {
    this.props.actions.districtShowEditForm({ show: true, object: item })
  };

  delete = (item) => {
    this.props.actions.districtDelete({ id: item.id })
  };

  render() {
    const { history, district, defaultFilter, activeFilter, topActions } = this.props;
    const { columnList, columnByName } = this.state;

    return (
      <TableList
        history={history}
        data={district}
        defaultFilter={defaultFilter}
        activeFilter={activeFilter}
        topActions={topActions}
        showSearch={true}
        columnList={columnList}
        columnByName={columnByName}
        onLoadData={this.load}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    district: state.district,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, actions.district), dispatch),
    dispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DistrictList);
